import * as S from './keyless-access.styled'

type KeylessBuildingNotConnectedProps = {
  title: string
  message: string
}

// Shared "building integration not connected" error state for every provider tab. Callers pass
// already-translated strings so the message can vary per state.
export const KeylessBuildingNotConnected = ({
  title,
  message,
}: KeylessBuildingNotConnectedProps) => (
  <S.TabContent>
    <S.FullWidthAlert type="error" title={title} message={message} />
  </S.TabContent>
)
